import React, { useState, useEffect, Fragment } from "react";
import { Input, Tabs, Col, Row, Button, message, Form, Spin, Modal } from "antd";
import "./Login.less";
import { UserOutlined, LockOutlined, RedoOutlined, QrcodeOutlined } from "@ant-design/icons";
import Axios from "axios";
import { url } from "../../config/global";

const { TabPane } = Tabs;

function SSOCallback(props) {
  const [login_text, setLoginText] = useState("Connecting to SSO...");

  const cekToken = async () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
     await Axios.post(`${url}/sso/token-validate`,{ token: token},{
      headers: {
         "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        sessionStorage.setItem("token", res.data.token);
        sessionStorage.setItem("username", res.data.data.username);
        sessionStorage.setItem("fullname", res.data.data.full_name);
        sessionStorage.setItem("id_user", res.data.data._id);
        sessionStorage.setItem("shift_code", res.data.data.shift_code);
        sessionStorage.setItem('np',  btoa(JSON.stringify(res.data.np)))
        sessionStorage.setItem(
          "avatar",
          res.data.data.photo ? res.data.data.photo_url : ""
        );
        sessionStorage.setItem(
          "permissions",
          JSON.stringify(res.data.permissions)
        );
        sessionStorage.setItem("role", res.data.data.role_id);
        sessionStorage.setItem("redirect", res.data.redirect);
        setLoginText("Signing you in...");
        setTimeout(() => {
            props.history.push('/'+res.data.redirect);
        }, 1500);
      })
      .catch((err) => {
         setTimeout(() => {
            Modal.error({
                    title: "Failed!",
                    content: "Gagal login menggunakan SSO , Silahkan coba lagi.",
            });
            props.history.push("/login");
        }, 1500);
            // props.history.push("");
      })
      
  }
  useEffect(() => {
    sessionStorage.clear()
    cekToken()
  },[])


  return (
   <Fragment>
         <Row>
           <Col xs={24}>
             <div className="main">
               <div>
                 <div className="img-box">
                   <img style={{ width: "100%" }}
                     src={require("../../assets/img/pt-sankei-dharma-indonesia.png")}
                     className="img-logo"
                   />
                 </div>
   
                 
   
                
   
                
                <div align="center" ><Spin />  {login_text}</div>
   
               </div>
             </div>
           </Col>
         </Row>
       </Fragment>

  );
}

export default SSOCallback;
